import type { FirePost, PostImage } from "../types/models";
import type { UploadedPostImage } from "./postAttachments";

function nonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

export function getPostImageUrls(post: Partial<FirePost> | null | undefined): string[] {
  if (!post) return [];

  const urls = [
    ...(Array.isArray(post.images)
      ? post.images.map((image) => image?.url).filter(nonEmptyString)
      : []),
    ...(Array.isArray(post.imageUrls) ? post.imageUrls.filter(nonEmptyString) : []),
    ...(post.attachmentType === "image" && nonEmptyString(post.attachmentUrl)
      ? [post.attachmentUrl]
      : []),
  ];

  return Array.from(new Set(urls));
}

export function buildPostImageEdit(params: {
  post: Partial<FirePost>;
  retainedUrls: string[];
  uploadedImages: UploadedPostImage[];
}) {
  const retainedSet = new Set(params.retainedUrls);
  const existingStructured = Array.isArray(params.post.images)
    ? params.post.images.filter((image): image is PostImage => nonEmptyString(image?.url))
    : [];
  const retainedStructured = existingStructured.filter((image) => retainedSet.has(image.url));
  const structuredUrls = new Set(retainedStructured.map((image) => image.url));
  const legacyImageUrls = params.retainedUrls.filter((url) => !structuredUrls.has(url));
  const images = [...retainedStructured, ...params.uploadedImages];
  return { images, legacyImageUrls };
}
